(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope,$state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.textErreur = 'login.messages.error.authentication';
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.mfaRequired = false;
        vm.mfaCode = null;
        vm.submitting = false;

        $timeout(function (){angular.element('[ng-model="vm.username"]').focus();});

        function cancel () {
            vm.password = null;
            vm.mfaCode = null;
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            if (vm.submitting) { return; }
            vm.submitting = true;
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                mfaCode: vm.mfaCode
            }).then(function () {
                vm.authenticationError = false;
                vm.password = null;
                vm.mfaCode = null;
                $uibModalInstance.close();
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                }
            }).catch(function (erreur) {
                var errorKey = erreur.data && erreur.data.errorKey;
                vm.textErreur = errorKey || erreur.headers('X-wamasysApp-error') || 'login.messages.error.authentication';
                vm.mfaRequired = !!(erreur.data && erreur.data.mfa_required);
                vm.mfaCode = null;
                // Le premier code demandé est une étape normale, pas une erreur de mot de passe.
                vm.authenticationError = vm.textErreur !== 'login.messages.error.mfaRequired';
                if (vm.mfaRequired) {
                    $timeout(function() { angular.element('[ng-model="vm.mfaCode"]').focus(); });
                }
            }).finally(function() {
                vm.submitting = false;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
